import { EntityBase } from './entity-base.model';

export class Lookup extends EntityBase {
  public SystemName: string;
  public Category: string;
  public Code: number;
  public Title: string;
}
